import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { supabase } from "../lib/supabase";

const Hero = () => {
  const [settings, setSettings] = useState({
    restaurant_name: "Karo Kebab House",
    hero_image_url: "https://images.unsplash.com/photo-1699728088614-7d1d4277414b?q=85",
    address: "Marktstraße 130, Hamburg"
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  async function fetchSettings() {
    const { data, error } = await supabase
      .from("site_settings")
      .select("*")
      .limit(1)
      .single();

    if (!error && data) {
      setSettings({
        restaurant_name: data.restaurant_name || "Karo Kebab House",
        hero_image_url:
          data.hero_image_url ||
          "https://images.unsplash.com/photo-1699728088614-7d1d4277414b?q=85",
        address: data.address || "Marktstraße 130, Hamburg"
      });
    }
  }

  const scrollToMenu = () => {
    const menuSection = document.getElementById("menu");
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const titleParts = (settings.restaurant_name || "Karo Kebab House").split(" ");

  const firstLine = titleParts.slice(0, 2).join(" ") || "KARO KEBAB";
  const secondLine = titleParts.slice(2).join(" ") || "HOUSE";

  return (
    <section id="home" className="hero-section relative">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${settings.hero_image_url})`,
        }}
      >
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content relative h-full flex items-center justify-center">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-4xl mx-auto space-y-6">
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold urban-heading fire-glow text-white leading-none">
              {firstLine}
            </h1>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold urban-heading text-orange-500 leading-none">
              {secondLine}
            </h2>

            <p className="text-xl md:text-3xl lg:text-4xl font-light text-white mt-8">
              Frisch. Heiß. Direkt vom Grill.
            </p>

            <div className="mt-12">
              <button
                onClick={scrollToMenu}
                className="btn-fire text-lg md:text-xl px-12 py-4 urban-heading"
              >
                Speisekarte ansehen
              </button>
            </div>

            <div className="mt-8 inline-block bg-black/50 backdrop-blur-sm px-6 py-3 rounded-full">
              <p className="text-white font-semibold">📍 {settings.address}</p>
            </div>
          </div>

          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
            <ChevronDown size={40} className="text-orange-500" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;